import React from 'react';
import classNames from 'classnames/bind';

// Components
import { Skeleton } from 'components';

// Styles
import styles from './styles.pcss';

const cn = classNames.bind(styles);

const TABS_COUNT = 2;
const CHILDREN_COUNT = 6;

const FamilySkeleton = () => (
  <div className={cn('skeleton')}>
    <div className={cn('skeleton__tabs')}>
      {Array.from(
        Array(TABS_COUNT).keys(),
      ).map((skeleton) => (
        <Skeleton key={skeleton} />
      ))}
    </div>
    <div className={cn('skeleton__deskription')}>
      <Skeleton />
    </div>
    <div className={cn('skeleton__items')}>
      {Array.from(
        Array(CHILDREN_COUNT).keys(),
      ).map((skeleton) => (
        <div key={skeleton} className={cn('skeleton__item')}>
          <Skeleton />
        </div>
      ))}
    </div>
  </div>
);

export { FamilySkeleton };
